export default function Marquee() {
  const items = [
    "Inloopdouches",
    "Toiletrenovaties",
    "Maatwerk",
    "Tegelwerk",
    "Sanitair",
    "Verlichting",
    "Vloerverwarming",
    "Marmer & Natuursteen",
    "Bedrijfspanden",
    "Particulier",
  ];
  const all = [...items, ...items];
  return (
    <div
      data-testid="marquee"
      className="border-y border-[#E5E7EB] bg-[#F5F7FB] py-6 overflow-hidden"
    >
      <div className="marquee">
        <div className="marquee-track">
          {all.map((it, i) => (
            <span
              key={i}
              className="text-2xl md:text-3xl font-bold uppercase tracking-tight text-[#0A0A0A] flex items-center gap-12"
            >
              {it}
              <span className="text-[#1E5BC6]">◆</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
